
/** Recibe un objeto como por ejemplo una Enum y retorna un listado de objetos con value y text */
export function mapToSelect(obj: any) {
  return Object.entries(obj).map(([value, text]) => ({ text, value }));
}
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Profesion from '@/model/Profesion';
import Agrupacion from '@/model/Agrupacion';

@Options({
  components: {},
  name: 'ListadoAgrupacionesProfesiones',
})
export default class ListadoAgrupacionesProfesiones extends Vue {
  @Prop()
  private profesiones!: Profesion[];

  @Prop({ type: Boolean, default: false })
  private loading!: boolean;

  @Prop()
  private pagination!: any;

  private columns = [
    {
      label: 'Títulos',
      field: 'profesion',
      headerStyle: 'width: 500px',
      align: 'center',
    },
    {
      label: 'Agrupaciones',
      field: 'agrupaciones',
      headerStyle: 'width: 500px',
      align: 'center',
    },
  ];
  private localPagination = this.pagination;

  showAgrupaciones(agrupaciones: Agrupacion[]) {
    return `(${agrupaciones.map((agrupacion) => agrupacion.descripcion).join(', ')})`;
  }

  @Watch('localPagination', { deep: true })
  paginateLocal(val: any) {
    this.$emit('pagination', val);
  }
}
